// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39TWt","col":"styles_col__3IkK4"};